var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _circle30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupergraphicsFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 295,
    viewBox: "0 0 1440 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1325.52,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1325.52 239.028)",
    fill: "#FFE10C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1339.78,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1339.78 224.766)",
    fill: "#FFE10C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1354.04,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1354.04 210.503)",
    fill: "#FFE10C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 196.24,
    r: 6.73132,
    transform: "rotate(-45 1368.31 196.24)",
    fill: "#FFE10C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 181.978,
    r: 6.73132,
    transform: "rotate(-45 1382.57 181.978)",
    fill: "#FFE10C"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 167.715,
    r: 6.73132,
    transform: "rotate(-45 1396.83 167.715)",
    fill: "#FFE10C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1339.78,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1339.78 253.291)",
    fill: "#FFE10C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1354.04,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1354.04 239.028)",
    fill: "#FFE10C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1368.31 224.766)",
    fill: "#FFE10C"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1382.57 210.503)",
    fill: "#FFE10C"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 196.24,
    r: 6.73132,
    transform: "rotate(-45 1396.83 196.24)",
    fill: "#FFE10C"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.1,
    cy: 181.978,
    r: 6.73132,
    transform: "rotate(-45 1411.1 181.978)",
    fill: "#FFE10C"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1354.04,
    cy: 267.554,
    r: 6.73132,
    transform: "rotate(-45 1354.04 267.554)",
    fill: "#FFE10C"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1368.31 253.291)",
    fill: "#FFE10C"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1382.57 239.028)",
    fill: "#FFE10C"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1396.83 224.766)",
    fill: "#FFE10C"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.1,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1411.1 210.503)",
    fill: "#FFE10C"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1425.36,
    cy: 196.24,
    r: 6.73132,
    transform: "rotate(-45 1425.36 196.24)",
    fill: "#FFE10C"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 281.816,
    r: 6.73132,
    transform: "rotate(-45 1368.31 281.816)",
    fill: "#FFE10C"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 267.554,
    r: 6.73132,
    transform: "rotate(-45 1382.57 267.554)",
    fill: "#FFE10C"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1396.83 253.291)",
    fill: "#FFE10C"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.09,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1411.09 239.028)",
    fill: "#FFE10C"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1425.36,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1425.36 224.766)",
    fill: "#FFE10C"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.62,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1439.62 210.503)",
    fill: "#FFE10C"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 296.079,
    r: 6.73132,
    transform: "rotate(-45 1382.57 296.079)",
    fill: "#FFE10C"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 281.816,
    r: 6.73132,
    transform: "rotate(-45 1396.83 281.816)",
    fill: "#FFE10C"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.1,
    cy: 267.554,
    r: 6.73132,
    transform: "rotate(-45 1411.1 267.554)",
    fill: "#FFE10C"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1425.36,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1425.36 253.291)",
    fill: "#FFE10C"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.62,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1439.62 239.028)",
    fill: "#FFE10C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4345_2941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -17,
    y: -51,
    width: 278,
    height: 282
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: 67.5554,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -17 67.5554)",
    fill: "#15A0DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.98633,
    y: 56.2644,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -3.98633 56.2644)",
    fill: "#15A0DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.02734,
    y: 44.9734,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 9.02734 44.9734)",
    fill: "#15A0DC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.041,
    y: 33.6825,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 22.041 33.6825)",
    fill: "#15A0DC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0547,
    y: 22.3915,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 35.0547 22.3915)",
    fill: "#15A0DC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0684,
    y: 11.1005,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 48.0684 11.1005)",
    fill: "#15A0DC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 61.082,
    y: -0.190552,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 61.082 -0.190552)",
    fill: "#15A0DC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0957,
    y: -11.4814,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 74.0957 -11.4814)",
    fill: "#15A0DC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.1094,
    y: -22.7725,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 87.1094 -22.7725)",
    fill: "#15A0DC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 100.123,
    y: -34.0635,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 100.123 -34.0635)",
    fill: "#15A0DC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 113.135,
    y: -45.3545,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 113.135 -45.3545)",
    fill: "#15A0DC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4345_2941)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118.681,
    cy: 85.7543,
    r: 87.222,
    fill: "#34B5EC"
  }))), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.6673,
    cy: 58.9934,
    r: 87.222,
    fill: "#34B5EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupergraphicsFooter);
export default __webpack_public_path__ + "static/media/supergraphics-footer.95e15f4fab216f8c1a77587da18f30ce.svg";
export { ForwardRef as ReactComponent };